import Like from '@components/Likes/Like';
import type {ReactElement} from 'react';

interface Props {
    link: string;
}

export default function VkLike(props: Props): ReactElement<Props> {
    function getParams(): string[] {
        return [`url=${encodeURIComponent(props.link)}`];
    }

    return (
        <Like
            likeUrl={`//vk.com/share.php?${getParams().join('&')}`}
            iconName="vk"
            className="likes__like--vk js-track-vk-share"
        />
    );
}
